import { Navigate, useParams } from 'react-router-dom';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

export default function CheckBusinessEntity({ children }) {
  const { businessEntityUuid: uuidFromParams } = useParams();
  const { businessEntityUuid } = useBusinessEntity();
  const dashboardPath = useDashboardPath();

  if (uuidFromParams === businessEntityUuid) {
    return children;
  }

  return <Navigate to={dashboardPath} />;
}
